module.exports = __webpack_public_path__ + "img/zhengqi.77d170e4.png";